import { render, staticRenderFns } from "./WorkDataTableFooter.vue?vue&type=template&id=4912ae88&scoped=true"
import script from "./WorkDataTableFooter.vue?vue&type=script&lang=js"
export * from "./WorkDataTableFooter.vue?vue&type=script&lang=js"
import style0 from "./WorkDataTableFooter.vue?vue&type=style&index=0&id=4912ae88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4912ae88",
  null
  
)

export default component.exports